import Image from 'components/Common/Image'
import { mediaQueryUp } from 'components/utils/breakpoint'
import type { LoyaltyOffersHubHeroCarouselItem } from 'loyalty/lib/loyaltyOffersHub/types'
import { rem } from 'polished'
import { forwardRef } from 'react'
import styled from 'styled-components'
import LoyaltyOffersHubHeroOfferContent from './LoyaltyOffersHubHeroOfferContent'

const DESKTOP_HERO_MIN_HEIGHT = 420
const DESKTOP_HERO_OVERLAY_VERTICAL_PADDING = 40

const HeroCarouselCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  ${mediaQueryUp.tablet} {
    display: grid;
    min-height: ${rem(DESKTOP_HERO_MIN_HEIGHT)};
  }
`

const HeroCarouselCardImageContainer = styled.div`
  flex-shrink: 0;
  height: ${rem(200)};

  ${mediaQueryUp.tablet} {
    grid-area: 1 / 1;
    height: 100%;
    overflow: hidden;
  }
`

const HeroCarouselCardImage = styled(Image)`
  display: block;
  width: 100%;
  height: 100%;
`

const HeroCarouselCardImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
`

const HeroCardContentContainer = styled.div`
  display: flex;
  flex: 1;

  ${mediaQueryUp.tablet} {
    box-sizing: border-box;
    grid-area: 1 / 1;
    align-items: center;
    min-height: ${rem(DESKTOP_HERO_MIN_HEIGHT)};
    padding-top: ${rem(DESKTOP_HERO_OVERLAY_VERTICAL_PADDING)};
    padding-right: ${rem(64)};
    padding-bottom: ${rem(DESKTOP_HERO_OVERLAY_VERTICAL_PADDING)};
    padding-left: clamp(${rem(64)}, 7vw, ${rem(84)});
    pointer-events: none;
    z-index: 1;
  }

  > * {
    flex: 1;

    ${mediaQueryUp.tablet} {
      flex: initial;
      pointer-events: auto;
    }
  }
`

interface Props {
  className?: string
  item: LoyaltyOffersHubHeroCarouselItem
  useImagePlaceholder?: boolean
}

const LoyaltyOffersHubHeroCarouselCard = forwardRef<HTMLDivElement, Props>(function LoyaltyOffersHubHeroCarouselCard({ className, item, useImagePlaceholder }, ref) {
  return <HeroCarouselCard ref={ref} className={className}>
    <HeroCarouselCardImageContainer>
      {useImagePlaceholder && <HeroCarouselCardImagePlaceholder />}
      {!useImagePlaceholder && <HeroCarouselCardImage
        id={item.imageId}
        fit="center"
        objectFit="cover"
      />}
    </HeroCarouselCardImageContainer>
    <HeroCardContentContainer>
      <LoyaltyOffersHubHeroOfferContent item={item} />
    </HeroCardContentContainer>
  </HeroCarouselCard>
})

export default LoyaltyOffersHubHeroCarouselCard
